<template>
  <div class="GlobalFormDemo">
    <GlobalForm :init-data="initData"  :form-item-list="formItemList" :inline="true" round :needBtnLoading="true"
      @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="所属门店" label-width="80px" slot="storeId"
        style="margin:0">
        <el-select v-model="storeId" placeholder="请选择所属门店" filterable clearable>
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <div style="text-align: right; margin-bottom: 20px" slot="AddSlot">
        <el-button size="small" type="warning" icon="el-icon-upload2" @click="openSyncDia">已有员工同步至黑名单</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addBlacklist">添加黑名单</el-button>
        <el-button size="small" type="success" :loading="exportLoading" icon="el-icon-download" @click="exportTable">导出Excel</el-button>
      </div>
    </GlobalForm>
    <el-dialog
      title="添加黑名单"
      :visible.sync="addBlacklistDiaVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="addBlacklistDiaClosed"
    >
      <div>
        <span class="tip">说明：添加到黑名单后，若收款人填写该人员，需要授权验证才可收款</span>
      </div>
      <el-form :model="addFormData" :rules="addFormRules" ref="addFormData" label-width="110px">
        <el-form-item label="添加方式" prop="addType">
          <el-radio-group v-model="addFormData.addType" @change="addTypeChange">
            <el-radio :label="1">手动录入</el-radio>
            <el-radio :label="2">导入黑名单列表</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="addFormData.addType === 1">
          <el-form-item label="人员姓名" prop="staffName">
            <el-input v-model="addFormData.staffName" placeholder="请输入人员姓名" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="人员手机号" prop="mobile">
            <el-input v-model="addFormData.mobile" placeholder="请输入人员手机号" @input="phoneInput" maxlength="11" ></el-input>
          </el-form-item>
          <el-form-item label="限制收款门店" prop="storeId">
            <el-select style="width: 100%;" v-model="addFormData.storeId" placeholder="请选择限制收款门店">
              <el-option v-for="item in syncStoreSelectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="模板">
            <el-button
              type="success"
              icon="el-icon-download"
              size="medium"
              @click="download"
              >下载数据模板</el-button
            >
          </el-form-item>
          <el-form-item label="表格上传" prop="fileName" class="fileName">
            <el-input
              v-model="addFormData.fileName"
              :disabled="true"
              size="medium"
              clearable
            >
            </el-input>
            <div style="float: right; position: relative">
              <el-button size="medium" type="warning" icon="el-icon-upload2"
                >上传表格</el-button
              >
              <input
                accept=".xls, .xlsx"
                ref="fileUpload"
                @change="onUploadList"
                type="file"
                style="
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: pointer;
                "
              />
            </div>
            <div style="color: #ff687b;line-height: 20px;">
              温馨提示:请按模板表格严格填写，带*的为必填项。仅支持.xls及.xlsx格式,单次上传大小不超过5M
            </div>
          </el-form-item>
        </template>
      </el-form>
      <div v-if="addFormData.addType === 2 && addFormData.fileName && unSyncStaffList.length">
        <span>共查询到<span class="btn" @click="staffClick">{{unSyncStaffList.length}}</span>个人员，请确认是否导入</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addBlacklistDiaVisible = false">取消</el-button>
        <el-button
          type="primary" :loading="addBtnLoading" @click="sureAdd">确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="导入已有人员"
      :visible.sync="syncDiaVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="syncDiaVisibleDiaClosed"
    >
      <div style="margin-bottom: 20px;">
        <span class="tip">说明：添加到黑名单后，若收款人填写该人员，需要授权验证才可收款</span>
      </div>
      <el-form :model="syncFormData" :rules="syncFormRules" ref="syncFormData" label-width="110px">
        <el-form-item label="选择同步角色" prop="staffType">
          <el-checkbox-group v-model="syncFormData.staffType" @change="staffTypeChange">
            <el-checkbox label="03">店长</el-checkbox>
            <el-checkbox label="04">店员</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择同步门店" prop="storeIds">
          <el-select style="width: 100%;" 
            v-model="syncFormData.storeIds"
            placeholder="请选择同步门店"
            filterable
            clearable
            multiple
            collapse-tags
            @change="storeIdsChange"
            @remove-tag="removeTag"
            >
            <el-option value="all" label="全选"  @click.native="selectAll"></el-option>
            <el-option v-for="item in syncStoreSelectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-if="syncFormData.staffType.length && syncFormData.storeIds.length && unSyncStaffList && unSyncStaffList.length">
        <span>共查询到<span class="btn" @click="staffClick">{{ unSyncStaffList.length }}</span>个人员可同步到黑名单，同步后默认限制在本门店不可收款，请确认是否操作</span>
      </div>
      <div v-if="syncFormData.staffType.length && syncFormData.storeIds.length && !unSyncStaffList.length">
        <span>暂未查询到可同步黑名单店员</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="syncDiaVisible = false">取消</el-button>
        <el-button
          type="primary" :loading="syncBtnLoading" @click="sureSyncAdd">确定</el-button
        >
      </span>
    </el-dialog>
    <DialogTbale @onClose="staffOnClose" :show="staffVisible" title="店员列表" :columns="DialogTableColumns" :data="unSyncStaffList.slice((storeStaffForm.pageNum - 1) * storeStaffForm.pageSize, storeStaffForm.pageNum * storeStaffForm.pageSize)"
      :currentPage="storeStaffForm.pageNum" :total="unSyncStaffList.length" :pageSize="storeStaffForm.pageSize" :width="1000"
      @handleCurrentChange="handleCurrentChangeDialog">
      <el-table-column label="职位" slot="staffType" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.staffType == '03'">门店店长</span>
          <span v-else-if="row.staffType == '04'">普通店员</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </DialogTbale>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import { MessageBox } from "element-ui";

export default {
  name: "Form",
  data() {
    return {
      initData: {
        entryTime: [
          moment().day(moment().day()-30).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      formItemList: [
        { slotName: "storeId" },
        {
          key: "staffName",
          type: "input",
          labelName: "人员姓名",
          placeholder: "请输入人员姓名查询",
          lableWidth: '70px'

        },
        {
          key: "mobile",
          type: "input",
          labelName: "人员手机号",
          placeholder: "请输入人员手机号查询",
          lableWidth: '90px'
        },
        {
          key: "createType",
          type: "select",
          lableWidth: "70px",
          labelName: "添加方式",
          placeholder: "请选择添加方式查询",
          option: [
            {
              value: '00',
              label: "已有店员同步",
            },
            {
              value: '01',
              label: "自主添加",
            },
          ],
        },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "添加时间",
          placeholder: "请选择添加时间",
          lableWidth: '80px',
          valueFormat: "timestamp",
          clearable: true
        },
        { slot: "AddSlot" },
      ],
      storeId: "",
      storeList: [],
      addBlacklistDiaVisible: false,
      addBtnLoading: false,
      addFormData: {
        addType: 1,
        staffName: "",
        mobile: "",
        storeId: "",
        fileName: ""
      },
      addFormRules: {
        addType: [
          { required: true, message: '请选择添加方式', trigger: 'change' }
        ],
        staffName: [
          { required: true, message: '请输入人员姓名', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入人员手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3-9]\d{9}$/;
              if (!reg.test(value)) {
                callback(new Error('请输入有效的手机号'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
        ],
        storeId: [
          { required: true, message: '请选择限制收款门店', trigger: 'change' }
        ],
        fileName: [
          {
            required: true,
            message: "请先上传表格数据",
            trigger: "blur",
          },
        ],
      },
      syncFormRules: {
        staffType: [
          { required: true, message: '请选择同步角色', trigger: 'change' }
        ],
        storeIds: [
          { required: true, message: '请选择同步门店', trigger: 'change' }
        ],
      },
      syncDiaVisible: false,
      syncFormData: {
        staffType: [],
        storeIds: []
      },
      storeIdRemove: false,
      syncStoreSelectList: [],
      syncBtnLoading: false,
      unSyncStaffList: [],
      staffVisible: false,
      DialogTableColumns: [
        { label: "店员姓名", prop: "staffName" },
        { label: "所属门店", prop: "storeName" },
        { slotName: "staffType" },
        { label: "联系电话", prop: "mobile" },
      ],
      storeStaffForm: {
        pageSize: 10,
        pageNum: 1,
      },
      exportLoading: false,
      SeachParams: {},
    };
  },
  created() {
    this.getStoreList()
    this.handleConfirm(this.initData)
  },
  methods: {
    //查询
    handleConfirm(data,cd) {
      let startTime = ""
      let endTime = ""
      if (data) {
        if (data.entryTime === null) {
          (startTime = ""), (endTime = "");
        } else {
          (startTime = moment(data.entryTime[0]).format("x")),
            (endTime = moment(data.entryTime[1]).format("x"));
        }
      } else {
        (startTime = ""), (endTime = "");
      }
      const SeachParams = {
        storeId: this.storeId,
        staffName: data && data.staffName ? data.staffName : "",
        mobile: data && data.mobile ? data.mobile : "",
        createType: data && data.createType ? data.createType : "",
        startTime,
        endTime,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        },
      };
      this.SeachParams = SeachParams
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    getStoreList() {
      _api.getStoreSelectOrder().then((res) => {
        this.storeList = res.data;
      });
    },
    addBlacklist() {
      this.getSyncStoreSelectList()
      this.addBlacklistDiaVisible = true
    },
    addTypeChange() {
      this.$refs['addFormData'].clearValidate();
    },
    addBlacklistDiaClosed() {
      this.addFormData = {
        addType: 1,
        staffName: "",
        mobile: "",
        storeId: "",
        fileName: ""
      }
      this.$nextTick(()=>{
        this.$refs['addFormData'].clearValidate();
      })
      if(this.$refs.fileUpload){
        this.$refs.fileUpload.value = "";
      }
    },
    phoneInput(){
      this.addFormData.mobile = this.addFormData.mobile.replace(/\D/g,'')
    },
    sureAdd() {
      this.$refs['addFormData'].validate((valid) => {
        if (valid) {
          this.addBtnLoading = true
          if(this.addFormData.addType === 1){
            let params = {
              mobile: this.addFormData.mobile,
              staffName: this.addFormData.staffName,
              storeId: this.addFormData.storeId,
            }
            _api.addBlacklistStaff(params).then(res => {
              if(res.code === 1){
                this.$message.success('操作成功')
                this.addBlacklistDiaVisible = false
                this.handleConfirm(this.initData)
              }
            }).finally(() => {
              this.addBtnLoading = false
            });
          }
          if(this.addFormData.addType === 2){
            _api.importBlacklistStaff({staffInfoList: this.unSyncStaffList}).then(res => {
              if(res.code === 1){
                this.$message.success('操作成功')
                this.addBlacklistDiaVisible = false
                this.handleConfirm(this.initData)
              }
            }).finally(() => {
              this.addBtnLoading = false
            });
          }
        } else {
          return false;
        }
      });
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入黑名单模板.xlsx";
      link.setAttribute("download", "导入黑名单模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    onUploadList(event, type) {
      console.log(event);
      let paramsExcel = {}
      paramsExcel.file = event.target.files;
      if (paramsExcel.file.length) {
        paramsExcel.excelName = event.target.files[0].name;
        this.addFormData.fileName = event.target.files[0].name;
      }
      if (!paramsExcel.file || paramsExcel.file.length == 0) {
        return this.$message.error("请上传表格");
      }
      const fd = new FormData();
      fd.append("file", paramsExcel.file[0]); //文件
      // 发起请求
      _api
        .analysisBlacklistStaffExcel(fd)
        .then((res) => {
          if (res.code === 1) {
            this.unSyncStaffList = res.data
            console.log(res,'resresresresresres');
          } else {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.addFormData.fileName = "";
          this.$refs.fileUpload.value = "";
        });
    },
    getSyncStoreSelectList() {
      _api.getSyncStoreSelectList().then((res) => {
        this.syncStoreSelectList = res.data;
      });
    },
    openSyncDia() {
      this.syncDiaVisible = true
      this.getSyncStoreSelectList()
    },
    syncDiaVisibleDiaClosed() {
      this.syncFormData = {
        staffType: [],
        storeIds: []
      }
      this.unSyncStaffList = []
      this.$nextTick(()=>{
        this.$refs['syncFormData'].clearValidate();
      })
    },
    sureSyncAdd() {
      this.$refs['syncFormData'].validate((valid) => {
        if (valid) {
          if(!this.unSyncStaffList.length){
            return this.$message.error('暂未查询到可同步黑名单店员')
          }
          let staffIds = []
          this.unSyncStaffList.forEach(item => {
            staffIds.push(item.staffId)
          })
          this.syncBtnLoading = true
          _api.bindUnSyncStaff({staffIds}).then(res => {
            if(res.code === 1){
              this.$message.success('操作成功！')
              this.syncDiaVisible = false
              this.handleConfirm(this.initData)
            }
          }).finally(() => {
            this.syncBtnLoading = false
          });
        } else {
          return false;
        }
      });
      
    },
    staffTypeChange() {
      if(this.syncFormData.staffType.length && this.syncFormData.storeIds.length){
        this.getUnSyncStaffList()
      }else{
        this.unSyncStaffList = []
      }
    },
    storeIdsChange(val) {
      if (!val.includes('all') && val.length === this.syncStoreSelectList.length) {
        this.syncFormData.storeIds.unshift('all')
      } else if (val.includes('all') && (val.length - 1) < this.syncStoreSelectList.length) {
        this.syncFormData.storeIds = this.syncFormData.storeIds.filter((item) => {
          return item !== 'all'
        })
      }
      if(this.syncFormData.staffType.length && this.syncFormData.storeIds.length){
        this.getUnSyncStaffList()
      }else{
        this.unSyncStaffList = []
      }
    },
    selectAll() {
      if (this.syncFormData.storeIds.length < this.syncStoreSelectList.length) {
        // 非全选时，点击选择全部
        this.syncFormData.storeIds = this.syncStoreSelectList.map((item) => {
            return item.id;
        });
        this.syncFormData.storeIds.unshift("all");
      } else {
          // 全选时，点击置空
          this.syncFormData.storeIds = [];
      }
      if(this.syncFormData.staffType.length && this.syncFormData.storeIds.length){
        this.getUnSyncStaffList()
      }else{
        this.unSyncStaffList = []
      }
    },
    removeTag(val) {
      console.log(val);
      if (val === 'all') {
        this.storeIdRemove = true
        this.syncFormData.storeIds = []
        this.unSyncStaffList = []
      }
    },
    getUnSyncStaffList() {
      let { staffType, storeIds} = this.syncFormData
      let params = {
        staffType,
        storeIds: storeIds.filter(item => item !== 'all')
      }
      _api.getUnSyncStaffList(params).then((res) => {
        if(!this.storeIdRemove){
          this.unSyncStaffList = res.data;
        }
        this.storeIdRemove = false
      });
    },
    staffOnClose() {
      this.staffVisible = false
    },
    staffClick() {
      this.staffVisible = true
    },
    handleCurrentChangeDialog(val) {
      this.storeStaffForm.pageNum = val
    },
    exportTable() {
      this.exportLoading = true
      _api.excelBlacklistStaffList({ ...this.SeachParams })
        .then((res) => {
          const content = res;
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            //
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "黑名单职员列表.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        }).finally(() => {
            this.exportLoading = false;
          });
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  .tip{
    font-size: 14px;
    color: #ff687b;
    margin-left: 10px;
  }
  // /deep/.el-form-item{
  //   margin-bottom: 10px;
  // }
  .fileName {
      /deep/.el-input {
        width: 230px;
      }
    }
}
.btn{
  color: #0981FF;
  text-decoration: underline;
  cursor: pointer;
}
</style>
